import { atom } from 'jotai';

export const selectedEnergyAtom = atom<{ electricity: boolean; gas: boolean }>({
  electricity: true,
  gas: true,
});
